export default class UrlService {
    public static getParam(key: string): string | null {
        const params = new URLSearchParams(window.location.search);
        return params.get(key);
    }

    public static openInNewWindow(url: string, param: string, name?: string, specs?: string) {
        const params =   window.location.search ? window.location.search + '&' + param : '?'+ param;
        window.open(url + params, name, specs);
    }

    public static clearParams(){
        window.history.replaceState({}, document.title, window.location.pathname);
    }

	public static get isPrintMode(){
		return  UrlService.getParam('printMode')  === 'enabled' ? true : false;
	}
}